import PropTypes from 'prop-types';

const matchProps = PropTypes.shape({
  path: PropTypes.string,
  url: PropTypes.string,
  isExact: PropTypes.bool,
  params: PropTypes.shape({}),
});

export default matchProps;
